import type { FaixaPrecoProduto } from '../api';

export function precoPorQuantidade(
  faixas: FaixaPrecoProduto[] | null | undefined,
  quantidade: number,
  valorPadrao: number,
): number {
  if (!faixas || faixas.length === 0) return valorPadrao;

  const faixa = faixas.find(
    (f) =>
      quantidade >= f.quantidadeMinima &&
      (f.quantidadeMaxima === null || quantidade <= f.quantidadeMaxima),
  );

  return faixa ? faixa.valorUnitario : valorPadrao;
}

export function menorPrecoDasFaixas(
  faixas: FaixaPrecoProduto[] | null | undefined,
  valorPadrao: number,
): number {
  if (!faixas || faixas.length === 0) return valorPadrao;
  return faixas.reduce((menor, faixa) => Math.min(menor, faixa.valorUnitario), valorPadrao);
}

export function quantidadeDoMenorPreco(
  faixas: FaixaPrecoProduto[] | null | undefined,
  precoExibido: number,
): number | null {
  if (!faixas || faixas.length === 0) return null;

  const melhor = faixas.reduce((atual, faixa) =>
    faixa.valorUnitario < atual.valorUnitario ? faixa : atual,
  );

  if (melhor.valorUnitario >= precoExibido) return null;

  return melhor.quantidadeMinima > 1 ? melhor.quantidadeMinima : null;
}

export interface ProximaFaixa {
  faltam: number;
  aPartirDe: number;
  precoUnitario: number;
}

export function proximaFaixaVantajosa(
  faixas: FaixaPrecoProduto[] | null | undefined,
  quantidadeAtual: number,
  precoAtual: number,
): ProximaFaixa | null {
  if (!faixas || faixas.length === 0) return null;

  const candidatas = faixas
    .filter((f) => f.quantidadeMinima > quantidadeAtual && f.valorUnitario < precoAtual)
    .sort((a, b) => a.quantidadeMinima - b.quantidadeMinima);

  const proxima = candidatas[0];
  if (!proxima) return null;

  return {
    faltam: proxima.quantidadeMinima - quantidadeAtual,
    aPartirDe: proxima.quantidadeMinima,
    precoUnitario: proxima.valorUnitario,
  };
}
